import React from 'react'
import { EDITOR_MODAL_ID } from '../../shared/constants'

export const Button = ({ label, emitter }) => {
  return (
    <>
      <div className="dropdown-divider"></div>
      <button
        className="dropdown-item d-flex justify-content-between align-items-center my-1"
        data-toggle="modal"
        data-target={`#${EDITOR_MODAL_ID}`}
        data-type="integration"
        onClick={() => {
          emitter.emit('open-modal')
        }}
      >
        {typeof label === 'string' && label.toUpperCase()}
        <i className="fa fa-exclamation ml-1"></i>
      </button>
    </>
  )
}
